/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import Projects from "layouts/dashboard/components/Projects";
import OrdersOverview from "layouts/dashboard/components/OrdersOverview";

function Dashboard() {
  const { sales, tasks } = reportsLineChartData;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3} px={3}>
        <MDBox mb={2}>
          <h2 style={{ margin: 0, fontSize: "1.5rem", fontWeight: "bold" }}>
            Quick Access
          </h2>
        </MDBox>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <MDBox
              component="a"
              href="/community"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "success.main",
                color: "white",
                textAlign: "center",
                padding: "1.5rem",
                borderRadius: "12px",
                textDecoration: "none",
                fontWeight: "bold",
                fontSize: "1.1rem",
                height: "140px",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "success.dark",
                  transform: "scale(1.05)",
                },
              }}
            >
              <span
                style={{
                  fontSize: "2rem",
                  marginBottom: "0.5rem",
                  color: "white",
                }}
              >
                🏘️
              </span>
              <div style={{ color: "white" }}>Communities</div>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <MDBox
              component="a"
              href="/buildstyles"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "primary.main",
                color: "white",
                textAlign: "center",
                padding: "1.5rem",
                borderRadius: "12px",
                textDecoration: "none",
                fontWeight: "bold",
                fontSize: "1.1rem",
                height: "140px",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "primary.dark",
                  transform: "scale(1.05)",
                },
              }}
            >
              <span
                style={{
                  fontSize: "2rem",
                  marginBottom: "0.5rem",
                  color: "white",
                }}
              >
                🏗️
              </span>
              <div style={{ color: "white" }}>Build Style</div>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <MDBox
              component="a"
              href="/features"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "info.main",
                color: "white",
                textAlign: "center",
                padding: "1.5rem",
                borderRadius: "12px",
                textDecoration: "none",
                fontWeight: "bold",
                fontSize: "1.1rem",
                height: "140px",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "info.dark",
                  transform: "scale(1.05)",
                },
              }}
            >
              <span
                style={{
                  fontSize: "2rem",
                  marginBottom: "0.5rem",
                  color: "white",
                }}
              >
                🛠️
              </span>
              <div style={{ color: "white" }}>Features</div>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <MDBox
              component="a"
              href="/property"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "warning.main",
                color: "white",
                textAlign: "center",
                padding: "1.5rem",
                borderRadius: "12px",
                textDecoration: "none",
                fontWeight: "bold",
                fontSize: "1.1rem",
                height: "140px",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "warning.dark",
                  transform: "scale(1.05)",
                },
              }}
            >
              <span
                style={{
                  fontSize: "2rem",
                  marginBottom: "0.5rem",
                  color: "white",
                }}
              >
                🏡
              </span>
              <div style={{ color: "white" }}>Property</div>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <MDBox
              component="a"
              href="/enquiry"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "secondary.main",
                color: "white",
                textAlign: "center",
                padding: "1.5rem",
                borderRadius: "12px",
                textDecoration: "none",
                fontWeight: "bold",
                fontSize: "1.1rem",
                height: "140px",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "secondary.dark",
                  transform: "scale(1.05)",
                },
              }}
            >
              <span
                style={{
                  fontSize: "2rem",
                  marginBottom: "0.5rem",
                  color: "white",
                }}
              >
                📞
              </span>
              <div style={{ color: "white" }}>Enquiry</div>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <MDBox
              component="a"
              href="/broker"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "error.main",
                color: "white",
                textAlign: "center",
                padding: "1.5rem",
                borderRadius: "12px",
                textDecoration: "none",
                fontWeight: "bold",
                fontSize: "1.1rem",
                height: "140px",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "error.dark",
                  transform: "scale(1.05)",
                },
              }}
            >
              <span
                style={{
                  fontSize: "2rem",
                  marginBottom: "0.5rem",
                  color: "white",
                }}
              >
                👥
              </span>
              <div style={{ color: "white" }}>Broker</div>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <MDBox
              component="a"
              href="/booking"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "success.main",
                color: "white",
                textAlign: "center",
                padding: "1.5rem",
                borderRadius: "12px",
                textDecoration: "none",
                fontWeight: "bold",
                fontSize: "1.1rem",
                height: "140px",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "success.dark",
                  transform: "scale(1.05)",
                },
              }}
            >
              <span
                style={{
                  fontSize: "2rem",
                  marginBottom: "0.5rem",
                  color: "white",
                }}
              >
                📋
              </span>
              <div style={{ color: "white" }}>Bookings</div>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <MDBox
              component="a"
              href="/inventory"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "primary.main",
                color: "white",
                textAlign: "center",
                padding: "1.5rem",
                borderRadius: "12px",
                textDecoration: "none",
                fontWeight: "bold",
                fontSize: "1.1rem",
                height: "140px",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "primary.dark",
                  transform: "scale(1.05)",
                },
              }}
            >
              <span
                style={{
                  fontSize: "2rem",
                  marginBottom: "0.5rem",
                  color: "white",
                }}
              >
                📦
              </span>
              <div style={{ color: "white" }}>Inventory</div>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      {/* <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="weekend"
                title="Bookings"
                count={281}
                percentage={{
                  color: "success",
                  amount: "+55%",
                  label: "than lask week",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="leaderboard"
                title="Today's Users"
                count="2,300"
                percentage={{
                  color: "success",
                  amount: "+3%",
                  label: "than last month",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="store"
                title="Revenue"
                count="34k"
                percentage={{
                  color: "success",
                  amount: "+1%",
                  label: "than yesterday",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="person_add"
                title="Followers"
                count="+91"
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Just updated",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="info"
                  title="website views"
                  description="Last Campaign Performance"
                  date="campaign sent 2 days ago"
                  chart={reportsBarChartData}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="success"
                  title="daily sales"
                  description={
                    <>
                      (<strong>+15%</strong>) increase in today sales.
                    </>
                  }
                  date="updated 4 min ago"
                  chart={sales}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="dark"
                  title="completed tasks"
                  description="Last Campaign Performance"
                  date="just updated"
                  chart={tasks}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={8}>
              <Projects />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <OrdersOverview />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer /> */}
    </DashboardLayout>
  );
}

export default Dashboard;
